import { Publication } from '../types/publication';

export const publications: Publication[] = [
  {
    id: 'hamamura2018separability',
    type: 'article',
    title: 'Separability Criterion for Quantum Effects',
    author: 'I. Hamamura',
    journal: 'Phys. Lett. A',
    volume: '382',
    number: '36',
    year: 2018,
    url: 'https://doi.org/10.1016/j.physleta.2018.06.043',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2019relation',
    type: 'article',
    title: 'Relation between state-distinction power and disturbance in quantum measurements',
    author: 'I. Hamamura and T. Miyadera',
    journal: 'J. Math. Phys.',
    volume: '60',
    number: '082103',
    year: 2019,
    url: 'https://doi.org/10.1063/1.5109446',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2017structure',
    type: 'article',
    title: '量子論における合成系の構造',
    author: '濵村 一航',
    journal: '物性研究・電子版',
    publisher: '物性研究刊行会',
    volume: '6',
    number: '2',
    pages: '062601',
    year: 2017,
    doi: '10.14989/225170',
    url: 'https://dx.doi.org/10.14989/225170',
    category: 'thesis',
  },
  {
    id: 'hamamura2017incompatibility',
    type: 'article',
    title: '操作の両立不可能性と情報擾乱の関係',
    author: '濵村一航',
    journal: '数理解析研究所講究録',
    publisher: '京都大学数理解析研究所',
    volume: '2059',
    pages: '113-129',
    year: 2017,
    category: 'kiyo',
  },
];
